import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import client from '../../service/graphql';
import { IGraphQLResponse } from '../../types/commonTypes';
import {
  IChatMessage,
  IChatMessageUpdatePayload,
  IGetChatListPayload,
  IGetChatListResponse,
  IGetChatMessagesPayload,
  IGetChatMessagesResponse,
  ISendMessagePayload,
  getChatList,
  getChatListFailure,
  getChatListSuccess,
  getChatMessages,
  getChatMessagesFailure,
  getChatMessagesSuccess,
  sendMessage,
  sendMessageFailure,
  sendMessageSuccess,
  updateMessageStatus,
} from './chatSlice';
import {
  GET_CHAT_LIST,
  GET_CHAT_MESSAGES,
  UPDATE_MESSAGE_STATUS,
} from '../../service/graphql/chatQuery';
import sendChatMessage from '../../service/api/chatApi';

function* watchGetChatList({ payload }: PayloadAction<IGetChatListPayload>) {
  try {
    const result: IGraphQLResponse<IGetChatListResponse> = yield call(client.query.bind(client), {
      query: GET_CHAT_LIST,
      variables: { ...payload },
    });
    yield put(getChatListSuccess(result.data.getChatList));
  } catch (error: unknown) {
    if (error instanceof Error) {
      yield put(getChatListFailure());
    }
  }
}

function* watchSendMessage({ payload }: PayloadAction<ISendMessagePayload>) {
  try {
    const { clientId, coachId, message, senderType, chatMessageType, assetFile, assetDuration } =
      payload;

    const response: IChatMessage = yield call(sendChatMessage, {
      clientId,
      coachId,
      message,
      senderType,
      assetDuration,
      assetFile,
      chatMessageType,
    });

    yield put(sendMessageSuccess({ message: response }));
  } catch (error: unknown) {
    if (error instanceof Error) {
      yield put(sendMessageFailure());
    }
  }
}

function* watchGetChatMessages({ payload }: PayloadAction<IGetChatMessagesPayload>) {
  try {
    const result: IGraphQLResponse<IGetChatMessagesResponse> = yield call(
      client.query.bind(client),
      {
        query: GET_CHAT_MESSAGES,
        variables: { ...payload },
      }
    );
    yield put(getChatMessagesSuccess(result.data.getChatMessages));
  } catch (error: unknown) {
    if (error instanceof Error) {
      yield put(getChatMessagesFailure());
    }
  }
}
function* watchUpdateMessageStatus({ payload }: PayloadAction<IChatMessageUpdatePayload>) {
  try {
    yield call(client.mutate.bind(client), {
      mutation: UPDATE_MESSAGE_STATUS,
      variables: {
        updateMessageStatusInput: {
          chatMessagesId: payload.chatMessagesId,
          messageStatusInput: payload.messageStatusInput,
        },
      },
    });
  } catch (error: unknown) {
    /* empty */
  }
}

export function* watchChatSagas() {
  yield takeLatest(getChatList, watchGetChatList);
  yield takeLatest(sendMessage, watchSendMessage);
  yield takeLatest(getChatMessages, watchGetChatMessages);
  yield takeLatest(updateMessageStatus, watchUpdateMessageStatus);
}

const chatSagas = watchChatSagas;
export default chatSagas;
